import React, { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { fs } from '../firebase';
import {
    doc,
    getDoc,
    setDoc,
    updateDoc,
    increment,
} from 'firebase/firestore';
import '../css/getcoins.css';
import { useNavigate } from 'react-router-dom';
import { getUserCardNumber } from '../utils/userUtils';
import { getLoyaltyPointsRate, calculateLoyaltyPoints } from '../utils/loyaltyRate';

const GetCoins = () => {
    const auth = getAuth();
    const navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [cardNumber, setCardNumber] = useState(null);
    const [isCardLinked, setIsCardLinked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [artCoinsToGet, setArtCoinsToGet] = useState(0);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (u) => {
            console.log('[Auth] Пользователь:', u);
            setUser(u);

            if (u) {
                try {
                    const userDocRef = doc(fs, 'users', u.uid);
                    const userDocSnap = await getDoc(userDocRef);

                    if (userDocSnap.exists()) {
                        const data = userDocSnap.data();
                        console.log('[UserDoc] Data:', data);
                        const cardNum = getUserCardNumber(data);

                        if (cardNum) {
                            console.log('[Card] Linked card:', cardNum);
                            setCardNumber(cardNum);
                            setIsCardLinked(true);
                        } else {
                            console.warn('[Card] Card not found');
                        }
                    } else {
                        console.warn('[UserDoc] User document not found');
                    }
                } catch (err) {
                    console.error('[UserDoc] Error fetching document:', err);
                }
            }
        });

        return unsubscribe;
    }, []);

    useEffect(() => {
        // alert('Order in progress')
        const fetchOrderCoins = async () => {
            const orderId = localStorage.getItem('firebaseOrderId');
            console.log('[OrderID] Из localStorage:', orderId);
            if (!orderId) return;

            try {
                const orderRef = doc(fs, 'DeliveryOrder', orderId);
                const orderSnap = await getDoc(orderRef);

                if (orderSnap.exists()) {
                    const data = orderSnap.data();
                    let totalAmount = 0;
                    if (data.orderReceipt && Array.isArray(data.orderReceipt)) {
                        data.orderReceipt.forEach(([venue, items]) => {
                            const venueTotal = items.reduce((sum, item) => sum + item.price, 0);
                            totalAmount += venueTotal;
                        });
                    }
                    const artCoins = calculateLoyaltyPoints(totalAmount, await getLoyaltyPointsRate());
                    console.log('[OrderData] ART coins to award:', artCoins);
                    setArtCoinsToGet(artCoins);
                } else {
                    console.warn('[OrderDoc] Заказ не найден в DeliveryOrder');
                }
            } catch (err) {
                console.error('[OrderDoc] Ошибка загрузки баллов:', err);
            }
        };

        fetchOrderCoins();
    }, []);

    const normalizeVenueKey = (name) =>
        name.replace(/\s+/g, '').replace(/\d/g, '').toLowerCase();

    const handleGetCoins = async () => {
        if (!user || !isCardLinked) {
            alert('Нужно авторизоваться и привязать карту лояльности');
            return;
        }

        const orderId = localStorage.getItem('firebaseOrderId');
        console.log('[handleGetCoins] orderId:', orderId);

        if (!orderId) {
            alert('ID заказа не найден');
            return;
        }

        setLoading(true);

        try {
            const orderRef = doc(fs, 'DeliveryOrder', orderId);
            const orderSnap = await getDoc(orderRef);

            if (!orderSnap.exists()) {
                throw new Error('Заказ не найден');
            }

            const orderData = orderSnap.data();

            // Points are now awarded for all payment methods
            // Removed payment method restriction

            if (orderData.coinsReceived) {
                alert('⚠️ Баллы за этот заказ уже были начислены.');
                navigate('/');
                return;
            }

            // Calculate ART coins from order total
            let totalAmount = 0;
            if (orderData.orderReceipt && Array.isArray(orderData.orderReceipt)) {
                orderData.orderReceipt.forEach(([venue, items]) => {
                    const venueTotal = items.reduce((sum, item) => sum + (item.price || 0), 0);
                    totalAmount += venueTotal;
                });
            }
            
            const artCoinsToAdd = calculateLoyaltyPoints(totalAmount, await getLoyaltyPointsRate());
            console.log('[handleGetCoins] ART coins to add:', artCoinsToAdd);

            if (artCoinsToAdd === 0) {
                alert('В заказе нет баллов.');
                return;
            }

            const coinsRef = doc(fs, 'coins', cardNumber);
            const coinsSnap = await getDoc(coinsRef);

            if (!coinsSnap.exists()) {
                console.log('[Firestore] Документ не существует, создаём с ART coins:', artCoinsToAdd);
                await setDoc(coinsRef, { artCoins: artCoinsToAdd });
            } else {
                console.log('[Firestore] Документ найден, добавляем ART coins:', artCoinsToAdd);
                await updateDoc(coinsRef, {
                    artCoins: increment(artCoinsToAdd)
                });
            }

            // Обновляем заказ, чтобы указать, что баллы уже начислены
            await updateDoc(orderRef, {
                coinsReceived: true
            });

            alert('🎉 Баллы успешно начислены!');
            navigate('/');

        } catch (err) {
            console.error('[handleGetCoins] Ошибка начисления баллов:', err);
            alert(`Ошибка: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="getcoins-container">
            <button
                onClick={handleGetCoins}
                disabled={loading}
                className="getcoins-button"
            >
                {loading
                    ? 'Loading...'
                    : user && isCardLinked
                        ? 'Get art coins'
                        : 'You need authorize and loyal card to get coins'}
            </button>

            {artCoinsToGet > 0 && (
                <div className="getcoins-points">
                    <h4 className="getcoins-title">ART Coins к зачислению:</h4>
                    <div className="getcoins-item">
                        <strong>{artCoinsToGet}</strong> ART Coins
                    </div>
                </div>
            )}
        </div>
    );
};

export default GetCoins;
